import type {ElementType, FC, PropsWithChildren} from "react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {noop} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

interface Props {
    className?: string;
    as?: ElementType;
}

export const OneColumnGridHolder: FC<PropsWithChildren<Props>> = (props) => {
    return (
        <Container as={props.as} className={props.className}>
            <Row>{props.children}</Row>
        </Container>
    );
};

export const OneColumnGridMain: FC<PropsWithChildren<Props>> = (props) => (
    <Col lgOffset={2} lg={12} className={props.className} as={props.as}>
        {props.children}
    </Col>
);

export const OneColumnGridFullWidth: FC<PropsWithChildren<Props> & {noGutters?: boolean}> = (props) => {
    const {isMobile} = useUserDevice();

    return (
        <Container fluid={isMobile || noop()} as={props.as} className={props.className}>
            <Col lg={16} as="aside" noGutters={props.noGutters}>
                {props.children}
            </Col>
        </Container>
    );
};
import type {ElementType, FC, PropsWithChildren} from "react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {noop} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";

interface Props {
    className?: string;
    as?: ElementType;
}

export const OneColumnGridHolder: FC<PropsWithChildren<Props>> = (props) => {
    return (
        <Container as={props.as} className={props.className}>
            <Row>{props.children}</Row>
        </Container>
    );
};

export const OneColumnGridMain: FC<PropsWithChildren<Props>> = (props) => (
    <Col lgOffset={2} lg={12} className={props.className} as={props.as}>
        {props.children}
    </Col>
);

export const OneColumnGridFullWidth: FC<PropsWithChildren<Props> & {noGutters?: boolean}> = (props) => {
    const {isMobile} = useUserDevice();

    return (
        <Container fluid={isMobile || noop()} as={props.as} className={props.className}>
            <Col lg={16} as="aside" noGutters={props.noGutters}>
                {props.children}
            </Col>
        </Container>
    );
};
